import { defineStore } from "pinia";
import { collection, query, where, getDocs, orderBy } from "firebase/firestore";
import { getPropertiesForConcierge } from "~/query/concierge";

export const useConciergeStore = defineStore("concierge", {
  state: () => ({
    conciergeReports: [],
    loading: false,
    error: null,
    properties: [],
  }),

  actions: {
    async fetchConciergeReports(userId) {
      this.loading = true;
      this.error = null;

      try {
        const db = useFirestore();
        const conciergeRef = collection(db, `personadata/${userId}/concierge/`);
        const q = query(conciergeRef, orderBy("timestamp", "desc"));

        const querySnapshot = await getDocs(q);

        this.conciergeReports = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
          timestamp: doc.data().timestamp?.toDate() || new Date(),
        }));

        return this.conciergeReports;
      } catch (error) {
        console.error("Error fetching concierge reports:", error);
        this.error =
          "Failed to load concierge reports. Please try again later.";
        throw error;
      } finally {
        this.loading = false;
      }
    },

    async fetchPropertiesForConcierge(properties) {
      this.properties = await getPropertiesForConcierge(properties);
    },

    resetStore() {
      this.conciergeReports = [];
      this.loading = false;
      this.error = null;
    },
  },

  getters: {
    getConciergeReportById: (state) => (id) =>
      state.conciergeReports.find((report) => report.id === id),
    getConciergeReports: (state) => state.conciergeReports,
    isLoading: (state) => state.loading,
    hasError: (state) => state.error !== null,
    getError: (state) => state.error,
    extractFormDatabyId: (state) => (id) => {
      const report = state.conciergeReports.find((report) => report.id === id);
      if (!report) return null;
      return report.shortlist.formData;
    },
  },
});
